import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  saasOrgData: cacheLs.get_saasOrgData()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
